import axios from "axios";
import { songRelatedPlatformURL } from '../_constants/api.constant'
import { getSelfToken } from '../../_helpers/auth/secureToken'
export async function handleRelatedPlatform(data,requestType) {
    switch(requestType)
    {
        case 'GETBYSONG':{
            const response = await axios.get(
                songRelatedPlatformURL.GETBYSONG+'/?search='+data.songId+'&user_id='+data.userId,
                {
                    headers: {
                        Authorization: 'Token ' + getSelfToken(),
                    },
                }
            ).then(function (response) {
                return response;
            }).catch(function (error) {
                // handle error
        
        
                console.log(error);
                console.log(error.response);
                return error.response;
            });
            return response;
        }

        case 'POST':{
            var localDataObj = data;
            const response = await axios.post(
                songRelatedPlatformURL.POST,localDataObj,
                {
                    headers: {
                        Authorization: 'Token ' + getSelfToken(),
                    },
                }
            ).then(function (response) {
                return response;
            }).catch(function (error) {
                // handle error
        
        
                console.log(error);
                console.log(error.response);
                return error.response;
            });
            return response;
        }

        case 'UPDATE':{
            var localDataObj = data;
            const response = await axios.put(
                songRelatedPlatformURL.PUT+'?id='+localDataObj.relatedPlatformLinkId,localDataObj,
                {
                    headers: {
                        Authorization: 'Token ' + getSelfToken(),
                    },
                }
            ).then(function (response) {
                return response;
            }).catch(function (error) {
                // handle error
                console.log(error);
                console.log(error.response);
                return error.response;
            });
            return response;
        }
        case 'DELETE':{
            var localDataObj = data;
            const response = await axios.delete(
                songRelatedPlatformURL.DELETE+'?id='+localDataObj.relatedPlatformLinkId,
                {
                    headers: {
                        Authorization: 'Token ' + getSelfToken(),
                    },
                }
            ).then(function (response) {
                return response;
            }).catch(function (error) {
                // handle error
                console.log(error);
                console.log(error.response);
                return error.response;
            });
            return response;
        }

        default:{
            return;
        }
    }

}